import preloadImage from './preloadImage/preloadImage';
import sameHeight from './sameHeight.directive';
import inputClear from './inputClear.directive';
import convertToNumber from './convertToNumber.directive';
import enterblocker from './enterblocker.directive';
import openInSafari from './openInSafari.directive';

let module = angular.module('app.directives', [
	preloadImage
])
.directive('sameHeight', sameHeight)
.directive('inputClear', inputClear)
.directive('convertToNumber', convertToNumber)
.directive('enterblocker', enterblocker)
.directive('openInSafari', openInSafari)
.name;

export default module;


// WEBPACK FOOTER //
// ./app/shared/directives/directives.js